import {OETarget} from '../../../react-oe/oe-target';
import {OEVersion} from '../../../react-oe/oe-version';
import OEIconCodes from '../../../lib/oe-icon-codes';
import {OETargetMenuDefs} from '../../elements/target-menu/oe-target-menu-defs';
import {OEAlphaBetaProdTypes} from '../oe-proto-model';

export const OEXRayTargetType = {
    xRayArm:                'xRayArm',
    xRayLeg:                'xRayLeg',
    xRayTrunk:              'xRayTrunk',
    anatomy:                'anatomy',
};

OEXRayTargetType.all = Object.values(OEXRayTargetType);

//
export class OEXRayTargetSelector {

    constructor(version)    {
        this.version = version;
    }

    get(target) {
        return OEXRayTargetSelector.get(target, this.version);
    }
};

OEXRayTargetSelector.targets = {
    [OETarget.xRayUpperExtremity]:  OETarget.xRayUpperExtremity,
    [OETarget.xRayLowerExtremity]:  OETarget.xRayLowerExtremity,
    [OETarget.xRayTrunk]:           OETarget.xRayTrunk,
};

OEXRayTargetSelector.targetsMin = {
    [OETarget.xRayUpperExtremity]:  OETarget.xRayUpperExtremityMobile,
    [OETarget.xRayLowerExtremity]:  OETarget.xRayLowerExtremityMobile,
    [OETarget.xRayTrunk]:           OETarget.xRayTrunkMobile,
};

OEXRayTargetSelector.get = function(target, version)    {
    if(!target || !version)    return target;
    const targets = version === OEVersion.xRayMin ? OEXRayTargetSelector.targetsMin : OEXRayTargetSelector.targets;
    let resTarget = targets[target];
    return resTarget ? resTarget : target;
};

//
export const OEXRayStartSelectionContentFactory = {

    createForVersion(version)   {

        let targeteSelector = new OEXRayTargetSelector(version);

        const content = {

            // alpha
            [OEXRayTargetType.xRayArm]: [
                {
                    subcategories: [
                        {
                            items: [
                                {target: targeteSelector.get(OETarget.xRayUpperExtremity), label: {text: 'Arm', id: 'start_view_title_x_ray_arm'}}
                            ]
                        }
                    ]
                }
            ],

            [OEXRayTargetType.xRayLeg]: [
                {
                    subcategories: [
                        {
                            items: [
                                {target: targeteSelector.get(OETarget.xRayLowerExtremity), label: {text: 'Leg', id: 'start_view_title_x_ray_leg'}}
                            ]
                        }
                    ]
                }
            ],

            [OEXRayTargetType.xRayTrunk]: [
                {
                    subcategories: [
                        {
                            items: [
                                {target: targeteSelector.get(OETarget.xRayTrunk), label: {text: 'Trunk', id: 'start_view_title_x_ray_trunk'}}
                            ]
                        }
                    ]
                }
            ],

            [OEXRayTargetType.anatomy]: [
                {
                    subcategories: [
                        {
                            items: [
                                OETargetMenuDefs.humanArm,
                                OETargetMenuDefs.humanShoulderGirdle
                            ]
                        },
                        {
                            items: [
                                OETargetMenuDefs.humanHip2,
                                OETargetMenuDefs.humanThighKnee,
                                OETargetMenuDefs.humanAnkleFoot
                            ]
                        },
                        {
                            items: [
                                OETargetMenuDefs.humanTrunk,
                                OETargetMenuDefs.humanNeckBack
                            ]
                        }
                    ]
                }
            ],

            // beta
            [OEXRayTargetType.xRayArm + OEAlphaBetaProdTypes.beta]: [
                {
                    subcategories: [
                        {
                            items: [
                                {target: targeteSelector.get(OETarget.xRayUpperExtremity), label: {text: 'Arm', id: 'start_view_title_x_ray_arm'}}
                            ]
                        }
                    ]
                }
            ],

            [OEXRayTargetType.xRayLeg + OEAlphaBetaProdTypes.beta]: [
                {
                    subcategories: [
                        {
                            items: [
                                {target: targeteSelector.get(OETarget.xRayLowerExtremity), label: {text: 'Leg', id: 'start_view_title_x_ray_leg'}}
                            ]
                        }
                    ]
                }
            ],

            [OEXRayTargetType.xRayTrunk + OEAlphaBetaProdTypes.beta]: [
                {
                    subcategories: [
                        {
                            items: [
                                {target: targeteSelector.get(OETarget.xRayTrunk), label: {text: 'Trunk', id: 'start_view_title_x_ray_trunk'}}
                            ]
                        }
                    ]
                }
            ],

            [OEXRayTargetType.anatomy + OEAlphaBetaProdTypes.beta]: [
                {
                    subcategories: [
                        {
                            items: [
                                OETargetMenuDefs.humanArm,
                                OETargetMenuDefs.humanShoulderGirdle
                            ]
                        },
                        {
                            items: [
                                OETargetMenuDefs.humanHip2,
                                OETargetMenuDefs.humanThighKnee,
                                OETargetMenuDefs.humanAnkleFoot
                            ]
                        },
                        {
                            items: [
                                OETargetMenuDefs.humanTrunk,
                                OETargetMenuDefs.humanNeckBack
                            ]
                        }
                    ]
                }
            ],

            // prod
            [OEXRayTargetType.xRayArm + OEAlphaBetaProdTypes.prod]: [
                {
                    subcategories: [
                        {
                            items: [
                                {target: targeteSelector.get(OETarget.xRayUpperExtremity), label: {text: 'Arm', id: 'start_view_title_x_ray_arm'}}
                            ]
                        }
                    ]
                }
            ],

            [OEXRayTargetType.xRayLeg + OEAlphaBetaProdTypes.prod]: [
                {
                    subcategories: [
                        {
                            items: [
                                {target: targeteSelector.get(OETarget.xRayLowerExtremity), label: {text: 'Leg', id: 'start_view_title_x_ray_leg'}}
                            ]
                        }
                    ]
                }
            ],

            [OEXRayTargetType.xRayTrunk + OEAlphaBetaProdTypes.prod]: [
                {
                    subcategories: [
                        {
                            items: [
                                {target: targeteSelector.get(OETarget.xRayTrunk), label: {text: 'Trunk', id: 'start_view_title_x_ray_trunk'}}
                            ]
                        }
                    ]
                }
            ],

            [OEXRayTargetType.anatomy + OEAlphaBetaProdTypes.prod]: [
                {
                    subcategories: [
                        {
                            items: [
                                OETargetMenuDefs.humanArm,
                                OETargetMenuDefs.humanShoulderGirdle
                            ]
                        },
                        {
                            items: [
                                OETargetMenuDefs.humanHip2,
                                OETargetMenuDefs.humanThighKnee,
                                OETargetMenuDefs.humanAnkleFoot
                            ]
                        },
                        {
                            items: [
                                OETargetMenuDefs.humanTrunk,
                                OETargetMenuDefs.humanNeckBack
                            ]
                        }
                    ]
                }
            ],
        };

        content.modules = [
            {id: OEXRayTargetType.xRayArm, icon: OEIconCodes.xRay.xRayArmTarget, categories: content[OEXRayTargetType.xRayArm]},
            {id: OEXRayTargetType.xRayLeg, icon: OEIconCodes.xRay.xRayLegTarget, categories: content[OEXRayTargetType.xRayLeg]},
            {id: OEXRayTargetType.xRayTrunk, icon: OEIconCodes.xRay.xRayTrunkTarget, categories: content[OEXRayTargetType.xRayTrunk]},
            {id: OEXRayTargetType.anatomy, icon: OEIconCodes.xRay.anatomyTarget, categories: content[OEXRayTargetType.anatomy]},
        ];

        content.modulesBeta = [
            {id: OEXRayTargetType.xRayArm, icon: OEIconCodes.xRay.xRayArmTarget, categories: content[OEXRayTargetType.xRayArm + OEAlphaBetaProdTypes.beta]},
            {id: OEXRayTargetType.xRayLeg, icon: OEIconCodes.xRay.xRayLegTarget, categories: content[OEXRayTargetType.xRayLeg + OEAlphaBetaProdTypes.beta]},
            {id: OEXRayTargetType.xRayTrunk, icon: OEIconCodes.xRay.xRayTrunkTarget, categories: content[OEXRayTargetType.xRayTrunk + OEAlphaBetaProdTypes.beta]},
            {id: OEXRayTargetType.anatomy, icon: OEIconCodes.xRay.anatomyTarget, categories: content[OEXRayTargetType.anatomy + OEAlphaBetaProdTypes.beta]},
        ];

        content.modulesProduction = [
            {id: OEXRayTargetType.xRayArm, icon: OEIconCodes.xRay.xRayArmTarget, categories: content[OEXRayTargetType.xRayArm + OEAlphaBetaProdTypes.beta]},
            {id: OEXRayTargetType.xRayLeg, icon: OEIconCodes.xRay.xRayLegTarget, categories: content[OEXRayTargetType.xRayLeg + OEAlphaBetaProdTypes.beta]},
            {id: OEXRayTargetType.xRayTrunk, icon: OEIconCodes.xRay.xRayTrunkTarget, categories: content[OEXRayTargetType.xRayTrunk + OEAlphaBetaProdTypes.beta]},
            {id: OEXRayTargetType.anatomy, icon: OEIconCodes.xRay.anatomyTarget, categories: content[OEXRayTargetType.anatomy + OEAlphaBetaProdTypes.prod]},
        ];

        return content;
    }
};
